import React, { useEffect, useState, useContext } from "react";
import { css } from "emotion";
import TitleBlock from "../components/TitleBlock";
import GenericCard from "../components/GenericCard";
import { boxStyles, colors, textSizes } from "../styles/theme";
import InviteListItem from "../components/invites/InviteListItem";
import logo from "../assets/logo-dark.svg";
import { Link, withRouter } from "react-router-dom";
import users from "../services/api/users";
import { GlobalContext } from "../context/GlobalState";

const Invitations = ({ history }) => {
  const { userData } = useContext(GlobalContext);
  const [invites, setInvites] = useState([]);

  if (!userData) {
    history.push("/signup?to=invitations");
  }

  const getInvitations = async () => {
    try {
      const { data } = await users.getInvites();
      console.log(data);
      setInvites(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getInvitations();
  }, []);

  return (
    <div className={container}>
      <div className="logo">
        <img src={logo} />
      </div>
      <div className="center">
        <TitleBlock
          title="Invitations"
          subtitle="These are the workspaces that you've been invited to."
        />
        <GenericCard style="invite-list">
          {invites.map((invite) => (
            <InviteListItem invite={invite} key={invite.workspaceId} />
          ))}
        </GenericCard>

        <p className="subtext">
          Need a new workspace? <Link to="/signup/workspace">Create New</Link>
        </p>
      </div>
    </div>
  );
};

export default withRouter(Invitations);

const container = css`
  display: flex;
  flex-direction: column;
  .center {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: ${boxStyles.standardPadding};
    width: 100%;
    margin: auto;

    .invite-list {
      padding: ${boxStyles.standardPadding};
      width: 100%;
    }
    .subtext {
      padding: ${boxStyles.standardPadding};
      font-size: ${textSizes.intermediate};
      color: ${colors.subtitleColor};
      a {
        text-decoration: none;
        color: ${colors.brandColor};
      }
    }
  }
  .logo {
    padding: ${boxStyles.standardPadding};
    img {
      max-height: 30px;
    }
  }

  @media screen and (min-width: ${boxStyles.desktopBreak}) {
    .center {
      width: 50%;
    }
  }
`;
